/* The ritual line in the cart — BEAMUN.
   Adds the missing step without leaving the bag, then asks the theme's own cart
   drawer to redraw itself so the progress and the next offer both move on.

   The listener sits on the document because the drawer replaces its own inner
   HTML on every cart change, which would take any closer listener with it. */

(function () {
  if (window.__bmCartRitualBound) return;
  window.__bmCartRitualBound = true;

  function say(message) {
    var status = document.querySelector('[data-cart-ritual-status]');
    if (status) status.textContent = message;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-ritual-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var id = parseInt(button.getAttribute('data-variant-id'), 10);
    var title = button.getAttribute('data-title') || 'That';

    if (!id) {
      say('That one could not be added just now.');
      return;
    }

    button.disabled = true;
    button.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'It could not be added.');
          return body;
        });
      })
      .then(function () {
        /* The drawer refetches itself and redraws, which rebuilds this strip.
           The word has to come after that, or the redraw wipes it. */
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () {
          say(title + ' is in your bag.');
        }, 900);
      })
      .catch(function (err) {
        button.disabled = false;
        button.textContent = 'Add';
        say(err.message || 'Something went wrong adding that.');
      });
  });
})();
